export const WELCOME_SCREEN = "Welcome"